import { signEdgeGridRequest } from './edgeGridAuth';

export interface AkamaiPurgeResult {
  estimatedSeconds?: number;
  purgeId?: string;
}

/**
 * Purge an Akamai CP code via Fast Purge (CCU v3).
 * Credentials are read from AKAMAI_* environment variables.
 */
export async function purgeAkamaiCpCode(cpCode: number): Promise<AkamaiPurgeResult> {
  const host = process.env.AKAMAI_HOST;
  const clientToken = process.env.AKAMAI_CLIENT_TOKEN;
  const accessToken = process.env.AKAMAI_ACCESS_TOKEN;
  const clientSecret = process.env.AKAMAI_CLIENT_SECRET;

  if (!host || !clientToken || !accessToken || !clientSecret) {
    throw new Error('Akamai credentials not configured');
  }

  const url = `https://${host}/ccu/v3/delete/cpcode/production`;
  const body = JSON.stringify({ objects: [cpCode] });

  const authorization = signEdgeGridRequest({
    method: 'POST',
    url,
    body,
    clientToken,
    accessToken,
    clientSecret,
  });

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: authorization,
    },
    body,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Akamai purge failed: ${response.status} ${text}`);
  }

  return (await response.json()) as AkamaiPurgeResult;
}
